import React from 'react';
import { Wrench } from 'lucide-react';
import { getDeadlineMarker } from '../../utils/deadlineMarkerUtils';

const colorClasses = {
  green: 'text-green-500',
  orange: 'text-orange-500',
  red: 'text-red-500'
};

/**
 * Samo jedna obojena ikonica: Phone (obaveštavanje) ili Wrench (servis) u zelenoj/narandžastoj/crvenoj.
 * size: 'sm' | 'md'
 */
const DeadlineMarker = ({ job, size = 'sm', className = '' }) => {
  const marker = getDeadlineMarker(job);
  if (!marker) return null;

  const iconSize = size === 'sm' ? 14 : 18;
  const isObavestenje = marker.phase === 'obavestenje';

  return (
    <span className={`inline-flex items-center flex-shrink-0 ${className}`} title={marker.label}>
      {isObavestenje ? (
        <span
          className={`inline-flex items-center justify-center rounded-full bg-white border border-current ${colorClasses[marker.color]} italic`}
          style={{
            fontSize: iconSize - 4,
            width: iconSize + 4,
            height: iconSize + 4,
            lineHeight: `${iconSize + 4}px`,
          }}
          aria-hidden
        >
          i
        </span>
      ) : (
        <Wrench size={iconSize} className={`${colorClasses[marker.color]} fill-current`} aria-hidden />
      )}
    </span>
  );
};

export default DeadlineMarker;
